/* eslint-disable no-shadow */
/* eslint-disable react/button-has-type */
import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "../../../services/actions"

import { generateArrayOfPageRangeWithDots } from "./Pagination.utils"
import Icon from "../Icon"

const Pagination = props => {
  const {
    data: { length },
    limit,
    totalCount,
    defaultPage,
    actions
  } = props

  const [currentPage, setCurrentPage] = useState(defaultPage - 1)
  const nextPage = currentPage + 1
  const previousPage = currentPage - 1

  const count = totalCount === 0 ? length : totalCount
  const pages = Math.ceil(count / limit)

  /**
   * The handleNavigation it's responsible by to
   * handle the changes of pagination/navigation
   * when the user click on the number or prev/next
   * buttons
   *
   * @param {DOM Event} e
   * @param {number} pageNumber
   * @returns {void}
   */
  function handleNavigation(e, pageNumber) {
    e.preventDefault()
    e.stopPropagation()
    if (
      pageNumber !== currentPage &&
      pageNumber >= 0 &&
      pageNumber + 1 <= pages
    ) {
      setCurrentPage(pageNumber)
      actions.setPagination(pageNumber)
    }
  }
  /**
   * The renderButtonPagination it's responsible by to render
   * the number of pagination
   *
   * @param {string} numberPage
   * @returns {JSX.Element}
   */
  function renderButtonPagination(numberPage) {
    return numberPage !== "..." ? (
      <button
        className="TableNavigationPageNumber"
        key={numberPage}
        title={`Navigation to page ${numberPage}`}
        onClick={e => handleNavigation(e, numberPage - 1)}
        disabled={currentPage === numberPage - 1}
      >
        {numberPage}
      </button>
    ) : (
      <span key={Math.random()} className="ellipsis">
        {numberPage}
      </span>
    )
  }
  /**
   * The renderPageNumbers it's responsible by to render the
   * number buttons of the table
   * @returns {[JSX.Element]}
   */
  function renderPageNumbers() {
    if (!pages || pages === 0) return null
    const numbers = []
    const pageRange = generateArrayOfPageRangeWithDots(pages, currentPage)
    for (let index = 0; index < pageRange.length; index += 1) {
      const numberPage = pageRange[index]
      numbers.push(renderButtonPagination(numberPage))
    }
    return numbers
  }

  return (
    <div className="TablePagination table-navigation">
      <div className="TableNavigation">
        <button
          className="TableNavigationArrow"
          onClick={e => handleNavigation(e, previousPage)}
          disabled={currentPage === 0}
        >
          <Icon name="caretLeft" />
        </button>
        <div className="TableNavigationPageNumbersContent">
          {renderPageNumbers()}
        </div>
        <button
          className="TableNavigationArrow"
          onClick={e => handleNavigation(e, nextPage)}
          disabled={nextPage === pages}
        >
          <Icon name="caretRight" />
        </button>
      </div>
    </div>
  )
}

Pagination.defaultProps = {
  data: [],
  limit: 10,
  totalCount: 0,
  defaultPage: 1
}

Pagination.propTypes = {
  actions: PropTypes.shape({
    setPagination: PropTypes.func
  }).isRequired,
  data: PropTypes.oneOfType([PropTypes.array]),
  defaultPage: PropTypes.number,
  limit: PropTypes.number,
  totalCount: PropTypes.number
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(actions, dispatch)
  }
}

// export Pagination
export default connect(mapStateToProps, mapDispatchToProps)(Pagination)
